import {Configuration} from "./generated";
import axios from "axios";


export let serverUrl = window.location.protocol + "//" + window.location.host;
if (window.location.hostname ==="localhost") {
    serverUrl = "https://rpls.rl.terrededonnees.fr/";
}



export const config = new Configuration({});

export const axiosInstance = axios.create({
});

export function getConfig() {
    return {
        headers: {},
    };

}




